export default __webpack_public_path__ + "static/media/ca.e591c33b.svg";